/* eslint react/prop-types: 0 */
import React, { useState, useCallback, useEffect, useContext, useRef } from "react";
import "./App.css";
import { Route, Redirect, NavLink, Switch } from "react-router-dom";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import Home from "./components/Home/home";

import Vozni_park from "./components/Vozni park/vozni park";
//FAKTURE
import Izvodi from "./components/Fakture/Izvodi";
import Izlazne_fakture from "./components/Fakture/Izlazne_fakture";
import Ulazne_fakture from "./components/Fakture/Ulazne_fakture";
import Izvestaji from "./components/Fakture/Izvestaji";
import Kompenzacije from "./components/Fakture/Kompenzacije";
//SERVIS
import UnosRadnihPop from "./components/Servis/unos radnih popup/unosradnihpopup.js"
import Vozila_servis from "./components/Servis/vozila_servis";
import Radni_nalozi from "./components/Servis/Radni_nalozi";
import PrijaveKvarova from "./components/Servis/PrijaveKvarova";
//TURE
import Ture from "./components/Ture/Ture";
import Ture_unos from "./components/Ture/Ture_unos";
import Izvestaji_ture from "./components/Ture/Izvestaji";
//PlanerTura
import PlanerTuraPregled from "./components/PlanerTura/PregledPlanaTure";
import PlanerTuraKalendar from "./components/PlanerTura/KalendarPlanaTure";
//Beleznica + pocetna chooser
import PocetnaChooser from "./components/Home/PocetnaChooser";
import BeleznicaUnos from "./components/Beleznica/BeleznicaUnos";
import BeleznicaKalendar from "./components/Beleznica/BeleznicaKalendar";
//Chat
import Chat from "./components/Chat/Chat";
import GPS from "./components/GPS/GPS";
import GpsIzvestaji from "./components/GPS/Izvestaji";
import TackeMapeHome from "./components/GPS/TackeMapeHome";
import { ChatSocketProvider } from "./context/ChatSocketContext";
import { CallProvider } from "./context/CallContext";
import CallModal from "./components/Chat/CallModal";
//Podrska
import Podrska from "./components/Podrska/Podrska";
//Vesti
import Vesti from "./components/Vesti/Vesti";

//MAGACIN
import Magacin_home from "./components/Magacin/Magacin_home.js";
//FINANSIJE
import ObracunPlate from "./components/Finansije/ObracunPlate";
import Blagajna from "./components/Finansije/Blagajna";
//MINISTARSTVO
import BelaPotvrda from "./components/Ministarstvo/BelaPotvrda";
//KAZNE
import KazneUcitavanje from "./components/Kazne/KazneUcitavanje";
import KazneEES        from "./components/Kazne/KazneEES";
import KazneIzvestaji  from "./components/Kazne/KazneIzvestaji";
import Izvestaji_ministarstvo from "./components/Ministarstvo/Izvestaji";

import Info from "./components/Info/info";
import Summary from "./Header/Summary";
import { AuthContext } from "./Header/auth - context";
import { useSelector, useDispatch, useStore } from "react-redux";
import Login from "./Login/login";
import AccessConfig from "./components/Administracija/Access_config.js";
import Administracija from "./components/Administracija/Administracija.js";
import KorisnikHome from "./components/Administracija/componentsTabs/KorisnikHome.js";
import { useHistory, useLocation } from "react-router-dom";
import Dozvole from "./components/Ministarstvo/Dozvole.js";
// PRIVREMENO ISKLJUČENO: import AlarmBlokadeConfirm from "./Popup/AlarmBlokadeConfirm.js";
import usePermission from "./custom/usePermission";
import { izlazneBadge, ulazneBadge, badgeTekst, osveziUlazneBadge } from "./custom/badgeFakture";
import { useTranslation } from "react-i18next";
import AlarmSession from "./Popup/AlarmSession.js";
import checkVersion from "./custom/checkVersion";
import APP_VERSION from "./version";
import CHANGELOG from "./changelog";
import OznakaOkruzenja from "./custom/OznakaOkruzenja";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

let logoutTimer;

function App() {
  const dispatch = useDispatch();
  /* Za obradu poruka iz drugih tabova: tamo treba TRENUTNA firma, a handler
     je registrovan jednom (useEffect []), pa bi `company` iz selektora bila zastarela. */
  const store = useStore();
  const company = useSelector((state) => state.company);
  const userData = useSelector((state) => state.user);
  const role = useSelector((state) => state.user_role);
  const eskaliran = useSelector((state) => state.eskaliran);
  /* Oznaka na tabu "Ulazne fakture" — broj faktura dodeljenih bas ovom korisniku. */
  const ulazneZaMene = useSelector((state) => state.ulazneZaMene || 0);
  const ulazneZaUnos = useSelector((state) => state.ulazneZaUnos || 0);
  const countInvoiceToCheck = useSelector((state) => state.countInvoiceToCheck || 0);
  const countAvansAlarm = useSelector((state) => state.countAvansAlarm || 0);
  const { can, permissions } = usePermission();
  const { t } = useTranslation();
  const trip = useSelector((state) => state.trip);
  const unreadChat = useSelector((state) => state.unreadChat || 0);
  const auth = useContext(AuthContext);
  const [token, setToken] = useState(false);
  const [newVersion, setNewVersion] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [user, setUser] = useState("");
  const [tokenExperation, setTokenExperation] = useState();
  const [menuOpen, setMenuOpen] = useState(false);
  let history = useHistory();
  const location = useLocation();
  const originalFavicon = useRef(null);
  const permToastRef = useRef(null);
  const tokenRef = useRef(null);
  const userIdRef = useRef(null);
  const channelRef = useRef(null);

  /* Provera verzije na svakom otvaranju aplikacije (deljena logika u custom/checkVersion.js —
     ista provera se poziva i pri loginu, da korisnik uvek dobije najnoviju publikovanu verziju). */
  useEffect(() => {
    checkVersion();
  }, []);

  /* Posle logina: ako je checkVersion upravo reload-ovao aplikaciju na novu verziju
     (ostavlja sessionStorage.versionReloadDone === trenutna verzija), prikaži obaveštenje jednom. */
  useEffect(() => {
    if (!token) return;
    const reloaded = sessionStorage.getItem('versionReloadDone');
    const notified = sessionStorage.getItem('versionNotified');
    if (reloaded && reloaded === APP_VERSION && notified !== APP_VERSION) {
      setNewVersion(APP_VERSION);
      sessionStorage.setItem('versionNotified', APP_VERSION);
    }
  }, [token]);

  const updateFavicon = useCallback((count) => {
    const faviconEl = document.querySelector("link[rel~='icon']");
    if (!originalFavicon.current && faviconEl?.href) {
      originalFavicon.current = faviconEl.href;
    }

    if (count === 0) {
      if (faviconEl && originalFavicon.current) faviconEl.href = originalFavicon.current;
      return;
    }

    const canvas = document.createElement('canvas');
    canvas.width = 32; canvas.height = 32;
    const ctx = canvas.getContext('2d');
    const label = count > 99 ? '99+' : String(count);
    const r = label.length > 1 ? 9 : 7;
    const cx = 32 - r - 1, cy = r + 1;

    const draw = (img) => {
      ctx.clearRect(0, 0, 32, 32);
      if (img) ctx.drawImage(img, 0, 0, 32, 32);
      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, 2 * Math.PI);
      ctx.fillStyle = '#25d366';
      ctx.fill();
      ctx.fillStyle = 'white';
      ctx.font = `bold ${r * 1.4}px Arial`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(label, cx, cy);
      let link = document.querySelector("link[rel~='icon']");
      if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link); }
      link.href = canvas.toDataURL('image/png');
    };

    if (originalFavicon.current) {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => draw(img);
      img.onerror = () => draw(null);
      img.src = originalFavicon.current;
    } else {
      draw(null);
    }
  }, []);

  const getUserLogged = (user) => {
    setUser(user);
  };
  
  /* `company` (oblik kao akcija COMPANY) šalje se uz token drugim tabovima.
     Bez nje bi tab koji primi novi token posle promene firme radio pod novom
     firmom, a u zaglavlju i dalje pokazivao staru (OP-124). */
  const login = useCallback((uid, token, name, lastname, expirationDate, shouldBroadcast = true, company = null) => {
    sessionStorage.setItem('sessionActive', '1');
    setToken(token);
    setUserId(uid);
    const tokenExpirationDate =
      expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60 * 8);
    setTokenExperation(tokenExpirationDate);
    dispatch({
      type: "USER",
      value: {
        userId: uid,
        token: token,
        userName: name,
        userSurname: lastname,
        expiration: tokenExpirationDate.toISOString(),
      },
    });
    if (shouldBroadcast) {
      channelRef.current?.postMessage({
        type: 'LOGIN',
        userId: uid,
        token,
        userName: name,
        userSurname: lastname,
        expiration: tokenExpirationDate.toISOString(),
        company,
      });
    }
  }, []);

  const logout = useCallback(() => {

    let requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + tokenRef.current,
      },
      body: JSON.stringify({
        user_id: userIdRef.current,
       }),
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/users", requestOptions)
      .then(handleErrors)
      .then(() => {
        console.log("Sesija završena!");
        document.title = `TMS`
        setUserId(null);
      })
      .catch(async (error) => {
        if (error instanceof Response) {
          try {
            const errorMessage = await error.json();
            console.log("Server error:", errorMessage);
          } catch (jsonErr) {
            console.log("Non-JSON error response");
          }
        } else {
          console.log("Client-side error:", error.message || error);
        }
        console.log("Error status:", error.status, error.statusText);
      });
    channelRef.current?.postMessage({ type: 'LOGOUT' });
    setToken(null);
    setTokenExperation(null);
    sessionStorage.removeItem('sessionActive');
    localStorage.removeItem("state");
    localStorage.removeItem("tms_tabs");
    document.cookie = "count=; expires=" + new Date(0).toUTCString();
    history.push("/");
  }, []);

  useEffect(() => {
    if (!location.pathname.startsWith('/ture')) {
      const base = 'TMS';
      document.title = unreadChat > 0 ? `(${unreadChat}) ${base}` : base;
    }
  }, [location.pathname]);

  // Live guard prava pristupa: kad admin ukine 'view' za modul u kom se korisnik trenutno nalazi
  // (socket 'permissions:update' osveži store), izbaci ga na početnu — bez re-logina.
  useEffect(() => {
    const PATH_MODULE = [
      ['/fakture', 'FAKTURE'], ['/ture', 'TURE'], ['/planerTura', 'PLANER'],
      ['/magacin', 'MAGACIN'], ['/servis', 'SERVIS'], ['/finansije', 'FINANSIJE'],
      ['/ministarstvo', 'MINISTARSTVO'], ['/kazne', 'KAZNE'], ['/podrska', 'PODRSKA'],
      ['/vesti', 'VESTI'], ['/chat', 'CHAT'], ['/info', 'INFO'],
    ];
    const hit = PATH_MODULE.find(([p]) => location.pathname.startsWith(p));
    if (hit && !can(hit[1], 'view')) {
      permToastRef.current?.show({ severity: 'warn', summary: t('common.pravaIzmenjenaNaslov'), detail: t('common.pravaIzmenjenaTekst'), life: 6000 });
      history.push('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, permissions]);

  useEffect(() => {
    updateFavicon(unreadChat);
    if ('setAppBadge' in navigator) {
      unreadChat > 0 ? navigator.setAppBadge(unreadChat) : navigator.clearAppBadge();
    }
    const base = document.title.replace(/^\(\d+\)\s/, '');
    document.title = unreadChat > 0 ? `(${unreadChat}) ${base}` : base;

    if (unreadChat === 0) return;

    // Re-apply prefix whenever another component changes document.title
    const titleEl = document.querySelector('title');
    if (!titleEl) return;
    let busy = false;
    const observer = new MutationObserver(() => {
      if (busy) return;
      const raw = document.title;
      if (!raw.startsWith(`(${unreadChat})`)) {
        busy = true;
        document.title = `(${unreadChat}) ${raw.replace(/^\(\d+\)\s/, '')}`;
        busy = false;
      }
    });
    observer.observe(titleEl, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, [unreadChat]);

  useEffect(() => {
    if(trip == null && document.title != 'TMS'){
      document.title = 'TMS'
    }
    if (token && tokenExperation) {
      const remainingTime = tokenExperation.getTime() - new Date().getTime();
      logoutTimer = setTimeout(logout, remainingTime);
    } else {
      clearTimeout(logoutTimer);
    }
  }, [token, logout, tokenExperation]);

  useEffect(() => { tokenRef.current = token; }, [token]);
  useEffect(() => { userIdRef.current = userId; }, [userId]);

  useEffect(() => {
    const channel = new BroadcastChannel('tms_auth');
    channelRef.current = channel;
    channel.addEventListener('message', (e) => {
      if (e.data.type === 'REQUEST_SESSION' && tokenRef.current) {
        channel.postMessage({ type: 'SESSION_ALIVE' });
      } else if (e.data.type === 'LOGIN') {
        const { userId, token, userName, userSurname, expiration, company } = e.data;
        const firmaTaba = store.getState().company?.companyId;
        login(userId, token, userName, userSurname, new Date(expiration), false);
        /* Drugi tab je promenio firmu (ili se prijavio pod drugom). Token je već
           preuzet — mora i firma, inače tab radi pod jednom firmom, a prikazuje
           drugu (upis, brisanje i učitavanje idu u firmu koju korisnik ne vidi).
           Tab se zatim ponovo učitava na početnu: ekran, brojači u zaglavlju i
           podaci na strani pripadaju prethodnoj firmi. Store je već sačuvan
           (saveState je sinhron), pa posle učitavanja kreće sa novim parom
           token + firma. Ista firma → menja se samo token, kao i do sada. */
        if (company && String(company.companyId) !== String(firmaTaba)) {
          dispatch({ type: 'COMPANY', value: company });
          window.location.assign('/');
        }
      } else if (e.data.type === 'LOGOUT') {
        setToken(null);
        setTokenExperation(null);
        sessionStorage.removeItem('sessionActive');
        localStorage.removeItem('state');
        localStorage.removeItem('tms_tabs');
        document.cookie = "count=; expires=" + new Date(0).toUTCString();
        history.push('/');
      }
    });
    return () => { channel.close(); channelRef.current = null; };
  }, []);

  useEffect(() => {
    const tabId = Math.random().toString(36).slice(2);
    sessionStorage.setItem('tms_tab_id', tabId);
    const activeTabs = JSON.parse(localStorage.getItem('tms_tabs') || '[]');
    activeTabs.push(tabId);
    localStorage.setItem('tms_tabs', JSON.stringify(activeTabs));

    const handleBeforeUnload = () => {
      const tid = sessionStorage.getItem('tms_tab_id');
      const tabs = JSON.parse(localStorage.getItem('tms_tabs') || '[]');
      const remaining = tabs.filter(id => id !== tid);
      if (remaining.length === 0) {
        localStorage.removeItem('tms_tabs');
        if (tokenRef.current && userIdRef.current) {
          const data = new URLSearchParams();
          data.append('token', tokenRef.current);
          data.append('user_id', String(userIdRef.current));
          navigator.sendBeacon(
            process.env.REACT_APP_BACKEND_URL + '/users/beacon-logout',
            data
          );
        }
      } else {
        localStorage.setItem('tms_tabs', JSON.stringify(remaining));
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  useEffect(() => {
    if(trip == null){
      document.title = 'TMS'
    }
    if (user === "" && userData && company) {
      setUser({
        name: userData.userName,
        surname: userData.userSurname,
        Naziv: company.companyName,
      });
    }
    if (role !== null) {
      setUserRole(role.roleId);
    }
    if (
      userData &&
      userData.token &&
      new Date(userData.expiration) > new Date()
    ) {
      if (sessionStorage.getItem('sessionActive')) {
        login(
          userData.userId,
          userData.token,
          userData.userName,
          userData.userSurname,
          new Date(userData.expiration),
          false
        );
      } else {
        const channel = channelRef.current;
        if (!channel) { localStorage.removeItem('state'); return; }
        let resolved = false;
        const tid = setTimeout(() => {
          if (!resolved) {
            localStorage.removeItem('state');
            localStorage.removeItem('tms_tabs');
          }
        }, 200);
        const onMsg = (e) => {
          if (e.data.type === 'SESSION_ALIVE' && !resolved) {
            resolved = true;
            clearTimeout(tid);
            channel.removeEventListener('message', onMsg);
            sessionStorage.setItem('sessionActive', '1');
            login(
              userData.userId,
              userData.token,
              userData.userName,
              userData.userSurname,
              new Date(userData.expiration),
              false
            );
          }
        };
        channel.addEventListener('message', onMsg);
        channel.postMessage({ type: 'REQUEST_SESSION' });
      }
    }
  }, [login, userRole]);

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  useEffect(() => {
    if (!token) return;
    fetch(process.env.REACT_APP_BACKEND_URL + '/plan/novi_count', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
    })
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(result => { dispatch({ type: 'PLAN_NOVI_SET', value: result.count || 0 });
              dispatch({ type: 'PLAN_NEPROCITANI_SET', value: result.neprocitani || 0 }); })
      .catch(() => {});
  }, [token]);

  useEffect(() => {
    if (!token) return;
    const refreshBadges = () => {
      fetch(process.env.REACT_APP_BACKEND_URL + '/alarms/info', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
      }).then(r => r.ok ? r.json() : null).then(result => {
        if (!result) return;
        const prov = result.find(x => x.TIP === 'FaktureProvera');
        /* Zbir svih grupa računa procedura ('Ukupno') — badge i strana Info
           tako ne mogu da se raziđu kao ranije, kad je ovde stajao ručni zbir
           dve od šest grupa. */
        const ukupno = result.find(x => x.TIP === 'Ukupno');
        dispatch({ type: 'COUNTER', value: ukupno?.ALARMI || 0 });
        dispatch({ type: 'COUNTER_INVOICE_CHECK', value: prov?.ALARMI || 0 });
      }).catch(() => {});
      fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetAvansAlarmCount', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
      }).then(r => r.ok ? r.json() : null).then(d => {
        if (d) dispatch({ type: 'AVANS_ALARM_SET', value: d?.[0]?.AlarmCount || 0 });
      }).catch(() => {});
    };
    refreshBadges();
    const id = setInterval(() => { refreshBadges(); osveziUlazneBadge(token, dispatch); }, 120000);
    return () => clearInterval(id);
  }, [token]);

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: !!token,
        token: token,
        userId: userId,
        login: login,
        logout: logout,
      }}
    >
      <ChatSocketProvider>
      <CallProvider>
      <CallModal />

      {/* Stoji IZNAD provere tokena da se vidi i na prijavi — da se zna u koje
          okruzenje se neko prijavljuje, a ne tek posle prijave. Sama se ne
          prikazuje kad je okruzenje produkcija. */}
      <OznakaOkruzenja />

      {!token && <Login login={login} getUser={getUserLogged} />}
      {token && (
        <div className="wrapper">
          {/* PRIVREMENO ISKLJUČENO na zahtev — popup "Imate NE NAPLAĆENE radne naloge ... blokade": */}
          {/* <AlarmBlokadeConfirm/> */}
          <AlarmSession/>
          <Toast ref={permToastRef} position="top-center" />
          <Dialog
            header={t('common.novaVerzijaNaslov')}
            visible={!!newVersion}
            onHide={() => setNewVersion(null)}
            style={{ width: '460px' }}
            breakpoints={{ '600px': '92vw' }}
            footer={<Button label={t('common.uRedu')} onClick={() => setNewVersion(null)} autoFocus />}
            modal
            draggable={false}
            resizable={false}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              <i className="pi pi-sparkles" style={{ fontSize: '2rem', color: '#22c55e' }} />
              <div>
                <p style={{ margin: 0 }}>{t('common.novaVerzijaTekst')}</p>
                <p style={{ margin: '6px 0 0', fontWeight: 700, fontSize: '1.15rem' }}>v{newVersion}</p>
              </div>
            </div>
            {(CHANGELOG[newVersion] || []).length > 0 && (
              <div style={{ marginTop: '14px', borderTop: '1px solid #eee', paddingTop: '12px' }}>
                <p style={{ margin: '0 0 8px', fontWeight: 700 }}>{t('common.staJeNovo')}</p>
                <ul style={{ margin: 0, paddingLeft: '20px', lineHeight: 1.5, maxHeight: '46vh', overflowY: 'auto' }}>
                  {(CHANGELOG[newVersion] || []).map((item, i) => (
                    <li key={i} style={{ marginBottom: '6px' }}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </Dialog>
          <Header logout={logout} logged={token} user={user} onMenuToggle={() => setMenuOpen(prev => !prev)}/>
          <div id="main">
            <Sidebar menuOpen={menuOpen} onClose={() => setMenuOpen(false)} />
            <div className="workspace">
                  <Route path="/fakture">
                <div id="servis_nav">
                  <NavLink className="button servis" style={{width: '20%', position: 'relative'}} to="/fakture/izlazne_fakture">
                    {t('subnav.izlazneFakture')}
                    {/* Zbir podtabova: Provera faktura + Pregled predračuna (custom/badgeFakture.js) */}
                    {izlazneBadge({ countInvoiceToCheck, countAvansAlarm }, can('FAKTURE', 'edit')) > 0 && (
                      <span className="sidebar-link-badge badge-blue"
                            style={{ position: 'absolute', top: '2px', right: '6px', zIndex: 1 }}>
                        {badgeTekst(izlazneBadge({ countInvoiceToCheck, countAvansAlarm }, can('FAKTURE', 'edit')))}
                      </span>
                    )}
                  </NavLink>
                  <NavLink className="button servis" style={{width: '25%', position: 'relative'}} to="/fakture/ulazne_fakture">
                    {t('subnav.ulazneFakture')}
                    {/* Zbir podtabova: Provera SEF + Fakture za unos. Puni se iz baze
                        (custom/badgeFakture.js), živo kad se dodeli faktura i na 2 min. */}
                    {ulazneBadge({ ulazneZaMene, ulazneZaUnos }) > 0 && (
                      <span className="sidebar-link-badge badge-blue"
                            style={{ position: 'absolute', top: '2px', right: '6px', zIndex: 1 }}>
                        {badgeTekst(ulazneBadge({ ulazneZaMene, ulazneZaUnos }))}
                      </span>
                    )}
                  </NavLink>
                  <NavLink className="button servis" style={{width: '20%'}} to="/fakture/izvodi">
                    {t('subnav.izvodi')}
                  </NavLink>
                  <NavLink className="button servis" style={{width: '20%'}} to="/fakture/kompenzacije">
                    {t('subnav.kompenzacije')}
                  </NavLink>
                  <NavLink className="button servis" style={{width: '20%'}} to="/fakture/izvestaji">
                    {t('subnav.izvestaji')}
                  </NavLink>
                </div>
                <Redirect to="/fakture/izlazne_fakture" />
                <Route
                  exact
                  path="/fakture/izlazne_fakture"
                  component={Izlazne_fakture}
                />
                <Route
                  exact
                  path="/fakture/ulazne_fakture"
                  component={Ulazne_fakture}
                />
                <Route
                  exact
                  path="/fakture/izvodi"
                  component={Izvodi}
                />
                {/* Analitička kartica je od 1.9.3 prvi tab unutar Izveštaja.
                    Stara putanja se preusmerava — link iz starog obeleživača
                    ili poruke ne sme da završi na praznoj stranici. */}
                <Route
                  exact
                  path="/fakture/kompenzacije"
                  component={Kompenzacije}
                />
                <Route
                  exact
                  path="/fakture/izvestaji"
                  component={Izvestaji}
                />
                <Route exact path="/fakture/analiticka_kartica">
                  <Redirect to="/fakture/izvestaji" />
                </Route>
              </Route>
                          <Route path="/ture">
          <Ture />
          <div id="servis_nav">
            <NavLink className="button servis" to="/ture/ture_unos">
              {t('subnav.ture')}
            </NavLink>
            <NavLink className="button servis" to="/ture/agencijski_nalozi">
              {t('subnav.agencijskiNalozi')}
            </NavLink>
            <NavLink className="button servis" to="/ture/izvestaji">
              {t('subnav.izvestaji')}
            </NavLink>
          </div>
          <Switch>
            <Redirect exact from="/ture" to="/ture/ture_unos" />
            <Route exact path="/ture/ture_unos" component={Ture_unos} />
            {/* Isti ekran, druga vrsta naloga — vidi Ture_unos.js. */}
            <Route exact path="/ture/agencijski_nalozi"
                   render={() => React.createElement(Ture_unos, { agencijski: true })} />
            <Route path="/ture/izvestaji" component={Izvestaji_ture} />
          </Switch>
        </Route>
              <Route exact path="/" component={Summary} />
              <Route exact path="/tabla_zaduzenja" component={Home} />
              {/* <Route exact path="/unos" component={Unos} /> */}
              <Route exact path="/magacin" component={Magacin_home} />
              <Route exact path="/vozni_park" component={Vozni_park} />
              <Route path="/servis">
                <div id="servis_nav">
                  <NavLink className="button servis" style={{width: '25%'}} to="/servis/unos_servisa">
                    {t('subnav.unosServisa')}
                  </NavLink>
                  <NavLink className="button servis" style={{width: '25%'}} to="/servis/prijave_kvarova">
                    {t('subnav.prijaveKvarova')}
                  </NavLink>
                  <NavLink className="button servis" style={{width: '25%'}} to="/servis/radni_nalozi">
                    {t('subnav.radniNaloziServisa')}
                  </NavLink>
                  <NavLink className="button servis" style={{width: '25%'}} to="/servis/vozila_servis">
                    {t('subnav.izvestaji')}
                  </NavLink>
                </div>
                <Redirect to="/servis/unos_servisa" />
                <Route
                  exact
                  path="/servis/unos_servisa"
                  component={UnosRadnihPop}
                />
                <Route
                  exact
                  path="/servis/prijave_kvarova"
                  component={PrijaveKvarova}
                />
                <Route
                  exact
                  path="/servis/radni_nalozi"
                  component={Radni_nalozi}
                />
                <Route
                  exact
                  path="/servis/vozila_servis"
                  component={Vozila_servis}
                />
              </Route>
               <Route path="/finansije">
                <div id="servis_nav">
                  <NavLink className="button servis" to="/finansije/blagajna">
                    {t('subnav.blagajna')}
                  </NavLink>
                  <NavLink className="button servis" to="/finansije/obracun_plate">
                    {t('subnav.obracunPlate')}
                  </NavLink>
                </div>
                <Redirect to="/finansije/blagajna" />
                <Route
                  exact
                  path="/finansije/blagajna"
                  component={Blagajna}
                />
                <Route
                  exact
                  path="/finansije/obracun_plate"
                  component={ObracunPlate}
                />
              </Route>
               <Route path="/ministarstvo">
                <div id="servis_nav">
                  <NavLink className="button servis" style={{width: '33.3%'}} to="/ministarstvo/bela_potvrda">
                    {t('subnav.belaPotvrda')}
                  </NavLink>
                  <NavLink className="button servis" style={{width: '33.3%'}} to="/ministarstvo/dozvole">
                    {t('subnav.dozvole')}
                  </NavLink>
                  <NavLink className="button servis" style={{width: '33.3%'}} to="/ministarstvo/izvestaji">
                    {t('subnav.izvestaji')}
                  </NavLink>
                </div>
                <Redirect to="/ministarstvo/bela_potvrda" />
                <Route
                  exact
                  path="/ministarstvo/bela_potvrda"
                  component={BelaPotvrda}
                />
                <Route
                  exact
                  path="/ministarstvo/dozvole"
                  component={Dozvole}
                />
                <Route
                  exact
                  path="/ministarstvo/izvestaji"
                  component={Izvestaji_ministarstvo}
                />
              </Route>
              <Route path="/planerTura">
                <div id="servis_nav">
                  <NavLink className="button servis" to="/planerTura/pregled">
                    {t('common.unos')}
                  </NavLink>
                  <NavLink className="button servis" to="/planerTura/kalendar">
                    {t('subnav.kalendar')}
                  </NavLink>
                </div>
                <Redirect to="/planerTura/pregled" />
                <Route
                  exact
                  path="/planerTura/pregled"
                  component={PlanerTuraPregled}
                />
                <Route
                  exact
                  path="/planerTura/kalendar"
                  component={PlanerTuraKalendar}
                />
              </Route>
              <Route exact path="/pocetna" component={PocetnaChooser} />
              <Route path="/beleznica">
                <div id="servis_nav">
                  <NavLink className="button servis" to="/beleznica/unos">
                    {t('common.unos')}
                  </NavLink>
                  <NavLink className="button servis" to="/beleznica/kalendar">
                    {t('subnav.kalendar')}
                  </NavLink>
                </div>
                <Redirect to="/beleznica/unos" />
                <Route exact path="/beleznica/unos" component={BeleznicaUnos} />
                <Route exact path="/beleznica/kalendar" component={BeleznicaKalendar} />
              </Route>
              <Route path="/kazne">
                <div id="servis_nav">
                  <NavLink className="button servis" style={{width: '25%'}} to="/kazne/ucitavanje">
                    {t('subnav.ucitavanje')}
                  </NavLink>
                  <NavLink className="button servis" style={{width: '25%'}} to="/kazne/ees_provera">
                    {t('subnav.eesProvera')}
                  </NavLink>
                  <NavLink className="button servis" style={{width: '25%'}} to="/kazne/izvestaji">
                    {t('subnav.izvestajiVozaci')}
                  </NavLink>
                  <NavLink className="button servis" style={{width: '25%'}} to="/kazne/izvestaji_vozila">
                    {t('subnav.izvestajiVozila')}
                  </NavLink>
                </div>
                {/* Sadržaj Tahografa ume da bude viši od ekrana (analiza, dijagram),
                    pa mu treba sopstveni skrol — inače propada ispod sidebara. */}
                <div className="kazne_main">
                  <Redirect to="/kazne/ucitavanje" />
                  <Route exact path="/kazne/ucitavanje"  component={KazneUcitavanje} />
                  <Route exact path="/kazne/ees_provera" component={KazneEES} />
                  <Route exact path="/kazne/izvestaji"   render={() => <KazneIzvestaji grupa="VOZACI" />} />
                  <Route exact path="/kazne/izvestaji_vozila" render={() => <KazneIzvestaji grupa="VOZILA" />} />
                </div>
              </Route>
              <Route exact path="/info" component={Info} />
              {/* Dodela prava ima svoju adresu, odvojeno od zupčanika.
                  Ko nema pravo, ne vidi ni stavku u meniju; ako ipak dođe
                  na adresu, vraća se na lična podešavanja. */}
              <Route
                exact
                path="/pristup"
                render={() => (can('PRISTUP', 'view') ? <AccessConfig /> : <Redirect to="/" />)}
              />
              <Route path="/settings">
                {/* Podnavigacije više nema: „Podešavanja pristupa" su otišla u
                    svoju stavku sidebara (/pristup), a „Korisnik" u zaglavlje
                    („Moj profil"), pa je ostalo jedno jedino dugme — a traka sa
                    jednim dugmetom ne nudi izbor, samo jede red. */}
                <Route exact path="/settings" render={() => <Redirect to="/settings/configuration" />} />
                <Route
                  exact
                  path="/settings/configuration"
                  render={() =>
                    /* Licna podesavanja su otisla u zaglavlje, pa iza zupcanika
                       ostaju samo sifarnici firme — bez prava nema sta da se vidi
                       i vraca se na pocetnu. */
                    can('ADMINISTRACIJA', 'view')
                      ? <Administracija />
                      : <Redirect to="/" />
                  }
                />
                {/* Stara adresa vodi na novu — zabeleženi linkovi i dalje rade. */}
                <Route exact path="/settings/access_config" render={() => <Redirect to="/pristup" />} />
                {/* Adresa ostaje zbog zabeleženih linkova; sadržaj je sada u
                    dijalogu „Moj profil" u zaglavlju. */}
                <Route
                  exact
                  path="/settings/korisnik"
                  component={KorisnikHome}
                />
              </Route>
              <Route exact path="/chat" component={Chat} />
              <Route path="/gps">
                <div id="servis_nav">
                  <NavLink className="button servis" to="/gps/mapa">
                    {t('subnav.gpsMapa')}
                  </NavLink>
                  {/* Mesto je GPS, jer su tačke sloj mape i tu se i koriste.
                      PRAVO ostaje ADMINISTRACIJA: tačka se deli sa celom mrežom
                      firmi, pa je ne sme menjati svako ko sme da vidi mapu — tako
                      stoji i u TMS_Backend/routes/tacke.js. Zato se stavka onome
                      ko to pravo nema ne prikazuje, umesto da se nudi pa odbija
                      sa 403. */}
                  {can('ADMINISTRACIJA', 'view') && (
                    <NavLink className="button servis" to="/gps/tacke">
                      {t('tacke.naslov')}
                    </NavLink>
                  )}
                  <NavLink className="button servis" to="/gps/izvestaji">
                    {t('subnav.gpsIzvestaji')}
                  </NavLink>
                </div>
                {/* Sadrzaj dobija ostatak visine ispod podnavigacije, isto kao kod
                    Tahografa — mapa se tako razvuce do dna bez racunanja u pikselima. */}
                <div className="gps_main">
                  <Switch>
                    <Redirect exact from="/gps" to="/gps/mapa" />
                    <Route exact path="/gps/mapa" component={GPS} />
                    {/* Provera i na ruti, ne samo na stavci: adresa se može
                        otvoriti i ukucavanjem. */}
                    <Route
                      exact
                      path="/gps/tacke"
                      render={() => (can('ADMINISTRACIJA', 'view')
                        ? <TackeMapeHome />
                        : <Redirect to="/gps/mapa" />)}
                    />
                    <Route exact path="/gps/izvestaji" component={GpsIzvestaji} />
                  </Switch>
                </div>
              </Route>
              <Route exact path="/podrska" component={Podrska} />
              <Route exact path="/vesti" component={Vesti} />
            </div>

          </div>
        </div>
      )}
      </CallProvider>
      </ChatSocketProvider>
    </AuthContext.Provider>
  );
}

export default React.memo(App);
